function classNames(...classes) {return classes.filter(Boolean).join(' ')}
const TeacherCalendarLargeEventChip = ({event, setOpenEvent}) => {
    return (
        <li key={event.id} className="list-none" onClick={() => setOpenEvent(event)}>
          <div className={classNames(`group flex transition-bg duration-300 hover:bg-blue-300 cursor-pointer py-0 px-1 my-1 ${event.isIntro ? 'bg-amber-100' : 'bg-blue-200'} rounded-md`)}>
            <div id="existing-event" className={`w-1 h-3 mt-1 rounded-sm bg-blue-500`}></div>
            <p className="flex-auto truncate text-xs mt-0.5 mb-0.5 ml-1 font-medium text-blue-800 group-hover:text-indigo-600">
              {event.name}
            </p>
          </div>
        </li>
    )
}
export default TeacherCalendarLargeEventChip